import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { setNavbar } from "../actions/navbar";

class NotFoundPage extends Component {
  componentDidMount() {
    const { props: { setNavbarActn = (e) => console.log(e) } = {} } = this;
    return setNavbarActn(null);
  }

  render() {
    return <Redirect to="/" />;
  }
}

function mapStateToProps(state = {}) {
  const { navbar } = state;
  return { navbar };
}

export default connect(mapStateToProps, {
  setNavbarActn: setNavbar,
})(NotFoundPage);



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js